import React from 'react'

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";

import {
    withStyles,
    TextField, MenuItem, Button, Typography, Grid
} from "@material-ui/core";

import { withFormik } from "formik";
import * as Yup from "yup";


const styles = () => ({
    card: {
        maxWidth: 420,
        margin: 12
    },
    container: {
        display: 'flex',
        justifyContet: 'center'
    },
    actions: {
        float: 'right'
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
})

const courseCategory = [
    {
        value: "webDevelopment",
        label: "Web Development"
    },
    {
        value: "networking",
        label: "Networking"
    },
    {
        value: "computerScience",
        label: "Computer Science"
    }
]

const FormikForm_ = (props) => {
    const {
        classes,
        values,
        touched,
        errors,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset
    } = props;

    return (
        <div className={classes.root}>

            <div className={classes.titleDiv}>
                <Typography variant="h2">Form with Formik</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>

                    <Card >

                        <form onSubmit={handleSubmit}>
                            <Card className={classes.card}>
                                <CardContent>

                                    <TextField
                                        id='firstName'
                                        label="First Name"
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={values.firstName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.firstName ? errors.firstName : ""}
                                        error={touched.firstName && Boolean(errors.firstName)}
                                    />

                                    <TextField
                                        id='lastName'
                                        label="Last Name"
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={values.lastName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.lastName ? errors.lastName : ""}
                                        error={touched.lastName && Boolean(errors.lastName)}
                                    />


                                    <TextField
                                        id="email"
                                        label="Email"
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        type="email"
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.email ? errors.email : ""}
                                        error={touched.email && Boolean(errors.email)}
                                    />

                                    <TextField
                                        select
                                        id="course"
                                        label="Course Category"
                                        value={values.course}
                                        onChange={handleChange("course")}
                                        helperText={touched.course ? errors.course : ""}
                                        error={touched.course && Boolean(errors.course)}
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                    >
                                        {courseCategory.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>

                                    <TextField
                                        id="password"
                                        label="password"
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        type="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.password ? errors.password : ""}
                                        error={touched.password && Boolean(errors.password)}
                                    />

                                    <TextField
                                        id="confirmPassword"
                                        label="Confirm password"
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        type="password"
                                        value={values.confirmPassword}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.confirmPassword ? errors.confirmPassword : ""}
                                        error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                                    />

                                </CardContent>
                                <CardActions className={classes.actions}>
                                    <Button color="primary" type="submit"
                                        disabled={isSubmitting}
                                    >Submit</Button>
                                    <Button color="primary" onClick={handleReset}>Clear</Button>
                                </CardActions>
                            </Card>
                        </form>
                    </Card>
                </Grid>
            </Grid>

        </div>
    )
}

const FormikForm = withFormik({
    mapPropsToValues: ({
        firstName,
        lastName,
        email,
        course,
        password,
        confirmPassword
    }) => {
        return {
            firstName: firstName || "",
            lastName: lastName || "",
            email: email || "",
            course: course || "",
            password: password || "",
            confirmPassword: confirmPassword || ""
        }
    },
    validationSchema: Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        email: Yup.string()
            .email("Enter a valid email")
            .required("Email is required"),
        course: Yup.string().required("select course category"),
        password: Yup.string()
            .min(8, "password must contain atleast 8 chrs")
            .required("Enter your password"),
        confirmPassword: Yup.string()
            .required("confirm your password")
            .oneOf([Yup.ref("password")], "password doesnt match")
    }),
    handleSubmit: (values, { setSubmitting }) => {
        setTimeout(() => {
            //submtting
            alert(JSON.stringify(values, null, 2))
            setSubmitting(false)
        }, 1000)
    }
}
)(FormikForm_)
export default withStyles(styles)(FormikForm); 